export const apiCreate = (): string => '/commercial/banks/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/banks/' : `/commercial/banks/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/banks/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/banks/delete/${id}`
